import {pipelineHasStep} from 'analysis-tool/data/getStepFromAnalysis';
import {GetAnalysis} from 'analysis-tool/graphql/__generated/GetAnalysis';
import {parseUri, setURLParams} from 'BenchlingUtil';
import {isInaccessible} from 'graphql-client/InaccessibleInfo';

export interface AnalysisQueryParameters {
  stepId: string | null;
}

export function parseAnalyticsUrlQueryParameters(): AnalysisQueryParameters {
  const {queryKey} = parseUri(window.location.href);
  return {
    stepId: queryKey.stepId ?? null,
  };
}

/**
 * Returns the analysis url with any applicable query parameters. If the analysis is inaccessible, then we
 * return undefined, which matches the expected behavior in the Analysis route
 */
export function getFullAnalysisUrl(analysis: GetAnalysis['analysis']): string | undefined {
  if (isInaccessible(analysis)) {
    return undefined;
  }

  const {stepId} = parseAnalyticsUrlQueryParameters();

  return setURLParams(analysis.url, {
    stepId: stepId && pipelineHasStep(analysis, stepId) ? stepId : null,
  });
}
